/** These echo the custom doc types defined in the FUNERAL_PLAN_DOCUMENT_TYPES
 * const in server/src/shared/models/print-documents.ts */
export const FUNERAL_PLAN_CUSTOM_DOCUMENTS = {
  farewill: {
    FUNERAL_PLAN_COVER_LETTER: 'farewill_funeral_plan_cover_letter',
    FUNERAL_PLAN_NOMINATED_REPRESENTATIVE_DOC:
      'farewill_funeral_plan_nominated_representative_doc',
    FUNERAL_PLAN_NOMINATED_REPRESENTATIVE_COVER_LETTER:
      'farewill_funeral_plan_nominated_representative_cover_letter',
    FUNERAL_PLAN_POLICY_CERTIFICATE: 'farewill_funeral_plan_policy_certificate',
    FUNERAL_PLAN_GUIDE_COVER_LETTER: 'farewill_funeral_plan_guide_cover_letter',
    FUNERAL_PLAN_ANNUAL_STATEMENT: 'farewill_funeral_plan_annual_statement',
    FUNERAL_PLAN_STATEMENT_POSTAL: 'farewill_funeral_plan_statement_postal',
    FUNERAL_PLAN_SECOND_MISSED_PAYMENT_LETTER:
      'farewill_funeral_plan_second_missed_payment_letter',
  },
  simplicity: {
    FUNERAL_PLAN_COVER_LETTER: 'simplicity_funeral_plan_cover_letter',
    FUNERAL_PLAN_NOMINATED_REPRESENTATIVE_DOC:
      'simplicity_funeral_plan_nominated_representative_doc',
    FUNERAL_PLAN_NOMINATED_REPRESENTATIVE_COVER_LETTER:
      'simplicity_funeral_plan_nominated_representative_cover_letter',
    FUNERAL_PLAN_GUIDE_COVER_LETTER:
      'simplicity_funeral_plan_guide_cover_letter',
    FUNERAL_PLAN_ANNUAL_STATEMENT: 'simplicity_funeral_plan_annual_statement',
    FUNERAL_PLAN_STATEMENT_POSTAL: 'simplicity_funeral_plan_statement_postal',
    FUNERAL_PLAN_SECOND_MISSED_PAYMENT_LETTER:
      'simplicity_funeral_plan_second_missed_payment_letter',
    FUNERAL_PLAN_CANCELLATION_LETTER:
      'simplicity_funeral_plan_cancellation_letter',
  },
  dignity: {},
}
